import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';

var normalizeValue = function normalizeValue(value) {
  if (typeof value === 'undefined') {
    return [];
  }

  return Array.isArray(value) ? value : [value];
};

export var useValue = function useValue(value, defaultValue) {
  var _useState = useState(normalizeValue(defaultValue)),
      _useState2 = _slicedToArray(_useState, 2),
      ownValue = _useState2[0],
      setOwnValue = _useState2[1];

  var controlled = typeof value !== 'undefined';

  if (controlled) {
    return [normalizeValue(value), function () {}];
  }

  return [ownValue, setOwnValue];
};